import { Container, Frame } from './style';

interface PdfViewerProps {
  base64: string;
  fileName?: string;
  height?: string;
}

export function PdfViewer({
  base64,
  fileName = 'documento.pdf',
  height = '700px',
}: PdfViewerProps) {
  const src = `data:application/pdf;base64,${base64}`;
  return (
    <Container>
      <Frame src={src} title={fileName} height={height} />
    </Container>
  );
}

export default PdfViewer;
